export default __webpack_public_path__ + "68e99a4cfb5d37aa72dad026501655eb.jpg";